// extracted by mini-css-extract-plugin
module.exports = {"aside":"c_c","list":"c_d","listItem":"c_f"};